import { useEffect, useState } from "react"
import styled, { keyframes } from "styled-components"

export const slightGrow = keyframes`
  0%   { transform: scale(1); }
  50%  {transform: scale(1.15); }
  100% { transform: scale(1); }
`

export const Indicator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  color: white;
  background-color: ${(props) => props.theme.colors.accent};

  position: absolute;
  top: -5px;
  right: -9px;

  min-width: 22px;
  height: 22px;
  border-radius: 11px;

  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px; // Because text has space underneath, slightly throwing off our centering

  &.animate {
    animation-name: ${slightGrow};
    animation-duration: 500ms;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
  }
`

const QuantityIndicator = ({ quantity }: { quantity: number }) => {
  const [animate, setAnimate] = useState(false)
  const [lastQuantity, updateLastQuantity] = useState(0)

  useEffect(() => {
    if (quantity > lastQuantity) {
      setAnimate(true)
    }
    updateLastQuantity(quantity)
  }, [quantity])

  return (
    <Indicator
      className={animate ? "animate" : ""}
      onAnimationEnd={() => setAnimate(false)}
    >
      {quantity}
    </Indicator>
  )
}

export default QuantityIndicator
